import type { RequestParameters } from "../types/common";
import { getAdvertiserId } from "../utils/permission.utils";

export const StyleConstants = {
    InsightCardSize: 320,
    InsightCardsPerRow: 3,
    InsightDetailWidth: "50vw",
};

export const ADVERTISER_ID_COLUMN = "advertiser_id";

export const ADVERTISER_ID_REQUEST_PARAMETER: RequestParameters = {
    [ADVERTISER_ID_COLUMN]: getAdvertiserId()!,
};

export const WB_ASSET_SLIDE_DELIMITER = ":";

export const SHARE_PITCHED_LINK_HELP_TIP =
    "Please note that files with passcode for external sharing will be automatically converted to .doc, .xls, and .ppt from their newer versions in Chrome. This is a known issue but does not impact the ability to download and open the encrypted files shared using this link.";

export const ACCOUNT_AGNOSTIC_VIEW =
    "IHub features (Insights, Your Insight decks and Workbench) are unavailable because a Salesforce account is not selected.";

export const ACCOUNT_AGNOSTIC_UNAVAILABLE =
    "This feature is unavailable because a Salesforce account is not selected.";

export const ACCOUNT_AGNOSTIC_VIEW_MARKETING_CONTENT_ONLY = {
    before: "Note - You are currently viewing InsightsHub without selecting a Salesforce account, and will only see Marketing Content. Please enter InsightsHub after selecting a Salesforce account in ",
    after: " to see Insights as well.",
};

export const ACCOUNT_AGNOSTIC_VIEW_WITH_ACCOUNT_SWITCHER =
    "Note - You are currently viewing InsightsHub without selecting a Salesforce account, and will only see Marketing Content and Packaged Insights. Please use the account switcher to select an account to see account specific Insights as well.";

export const UAT_PACKAGED_INSIGHT_SELECTED =
    "Note - You are currently viewing InsightsHub with the UAT Packaged Insight Flag, and will only see UAT Packaged Insights. Please remove this flag from the url to view other insights and markeing contents.";

export const SINGLE_IDENTIFIER_VIEW =
    "Note - You are currently viewing InsightHub in Single Identifier view. Please remove the Identifier filter to go back to original search experience.";

// Remove the text below once we are able to filter by language
export const XWAI_ENGLISH_CONTENTS_ONLY =
    "Results will only contain English content.";

export const getBookofBusinessPath = (): string => {
    const baseUrl = window.location.origin;
    const path = "/book-of-business";
    return `${baseUrl}${path}`;
};

export const CLIENT_ID = "insights_hub";
